import * as types from '../constants/actionTypes';

export function login(model) {
    return { type: types.LOGIN_REQUEST, login: model };
}

export function createUser(model) {
    return { type: types.CREATE_USER, user: model };
}

export function changePassword(model) {
    return { type: types.CHANGE_USER_PASSWORD, changepassword: model };
}

export function changeEmployeePassword(model) {
    return { type: types.CHANGE_EMPLOYEE_PASSWORD, changeemployeepassword: model };
}

export function resetPassword(username) {
    return { type: types.RESETPASSWORD_USER, username };
}

export function forgetPassword(username) {
    return { type: types.FORGETPASSWORD_USER, username };
}

export function createPatient(patient) {
    return { type: types.SAVE_PATIENT, patient };
}

export function getRoles() {
    return { type: types.GET_USER_ROLES };
}

export function unlockAccount(username) {
    return { type: types.UNLOCK_ACCOUNT, username }
}

export function unlockPatientAccount(username, compName) {
    return { type: types.UNLOCK_PATIENT_ACCOUNT, username, compName }
}

export function verifyCredential(model) {
    return { type: types.VERIFY_CREDENTIAL, model }
}

export function clearVerifyCredential() {
    return { type: types.VERIFY_CREDENTIAL_CLEAR }
}

// USER ROLE

export function getRole(id, compName) {
    return { type: types.GET_ROLE, id, compName };
}
export function saveRole(model, compName) {
    return { type: types.SAVE_ROLE, model, compName }
}
export const updateRole = (model, compName) => {
    return { type: types.UPDATE_ROLE, model, compName }
}
export const deleteRole = (id) => {
    return { type: types.DELETE_ROLE, id }
}

export const getPolicies = () => {
    return { type: types.GET_POLICIES }
}

export function getUserReportRole(id) {
    return { type: types.USERROLE_REPORT_GET, id };
}

export function getUserPageRole(id) {
    return { type: types.USERROLE_PAGE_GET, id };
}

export function getUserRoleReportByName(roleName) {
    return { type: types.USERROLE_REPORT_GETBYNAME, roleName };
}

export function getUserRolePageByName(roleName) {
    return { type: types.USERROLE_PAGE_GETBYNAME, roleName };
}

export function saveUserReportRole(userRole, compName) {
    return { type: types.USERROLE_REPORT_SAVE, userRole, compName };
}

export function saveUserPageRole(userRole, compName) {
    return { type: types.USERROLE_PAGE_SAVE, userRole, compName };
}

// PATIENT
export function getPatientDetails(model) {
    return { type: types.GET_PATIENT_DETAIL, model };
}
export function resetPatientLists() {
    return { type: types.RESET_PATIENT_LISTS }
}
export function patientSpringBigNotifications(model) {
    return { type: types.SPRING_BIG_NOTIFICATIONS, model };
}
export function editEliteMembership(model) {
    return { type: types.EDIT_ELITE_MEMBERSHIP, model }
}

// PRODUCT

export function initializePurchaseOrderProductList() {
    return { type: types.INITIALIZE_POPAGE_PRODUCT_LIST };
}
export function saveProduct(product, compName) {
    return { type: types.CREATE_PRODUCT, product, compName };
}

export function getProduct(productId, branchId, compName) {
    return { type: types.GET_PRODUCT, productId, branchId, compName };
}

export function getProductById(productId, branchId) {
    return { type: types.GET_PRODUCT_BY_ID, productId, branchId };
}

export function editProductUPC(model) {
    return { type: types.EDIT_PRODUCT_UPC, model }
}

export function updateUnitPriceDatabase(model) {
    return { type: types.UPDATE_UNIT_PRICE_DATABASE, model }
}

export function unreceivePOProduct(model) {
    return { type: types.UNRECEIVE_PO_PRODUCT, model }
}

export function unreceiveAll(model) {
    return { type: types.UNRECEIVE_ALL, model }
}

export function deletePO(model) {
    return { type: types.DELETE_PO, model }
}

export function getProductByBarcode(barcode, branchId) {
    return { type: types.GET_PRODUCT_BY_BARCODE, barcode, branchId };
}

export function checkComboProductQuantity(branchId, comboId, comboProductClicked, quantityAddedBack) {
    return { type: types.CHECK_COMBO_PRODUCT_QUANTITY, branchId, comboId, comboProductClicked, quantityAddedBack };
}

export function cleanProductDetail() {
    return { type: types.CLEAN_PRODUCT_DETAIL };
}

export function cleanOrderDetail(itemsPerPage) {
    return { type: types.CLEAN_ORDER_DETAIL, itemsPerPage };
}

export function clearPriceMatchRows() {
    return { type: types.CLEAR_PRICE_MATCH_ROWS };
}

export function clearOfflineOrderError() {
    return { type: types.CLEAR_OFFLINE_ORDER_ERROR };
}

export function getProducts(model) {
    return { type: types.GET_PRODUCTS, model };
}

export function getProductsCampaign(model) {
    return { type: types.GET_PRODUCTS_CAMPAIGN, model };
}

export function getProductsCarousel(model) {
    return { type: types.GET_PRODUCTS_CAROUSEL, model };
}

export function clearProductsCarousel() {
    return { type: types.PRODUCTS_CLEAR_CAROUSEL }
}

export function deleteCarousel(model) {
    return { type: types.CAROUSEL_DELETE, model }
}

export function getProductsByCategory(typeId, branchId) {
    return { type: types.GET_PRODUCTS_BY_CATEGORY, typeId, branchId };
}

export function getProductLocations(branchId) {
    return { type: types.GET_PRODUCT_LOCATIONS, branchId };
}

export function getProductTypes() {
    return { type: types.PRODUCT_TYPES_GET };
}

export function getProductCategories(branchId) {
    return { type: types.GET_PRODUCTS_CATEGORIES, branchId };
}

export function getProductCategoriesDropdown(isCannabis) {
    return { type: types.GET_PRODUCTS_CATEGORIES_DROPDOWN, isCannabis };
}

export function resetProductCategories() {
    return { type: types.REST_PRODUCT_CATEGORIES };
}

export function getProductOrders(model) {
    return { type: types.GET_PRODUCT_ORDERS, model };
}

export function getCampaignList(data) {
    return { type: types.GET_CAMPAIGN_LIST, data };
}

export function getPurchaseOrderList(data) {
    return { type: types.GET_PURCHASE_ORDER_LIST, data };
}

export function resetProductList() {
    return { type: types.RESET_PRODUCT_LIST }
}

export function deleteProduct(model) {
    return { type: types.DELETE_PRODUCT, model };
}

export function inventoryAdjustRoundPrices(model) {
    return { type: types.INVENTORY_ADJUST_ROUND_PRICES, model }
}

export function bulkUpdateMemberPrice(model) {
    return { type: types.BULK_UPDATE_MEMBER_PRICE, model }
}
export function getBulkMemberPriceHistory(branchId) {
    return { type: types.GET_BULK_MEMBER_PRICE_HISTORY, branchId }
}
export function getProductCategoryBulkUpdatePriceHistory(branchId, categoryId) {
    return { type: types.GET_PRODUCT_CATEGORY_BULK_UPDATE_PRICE_HISTORY, branchId, categoryId }
}
export function getBulkMemberPriceCategoryHistory(branchId) {
    return { type: types.GET_BULK_MEMBER_PRICE_CATEGORY_HISTORY, branchId }
}
export function categoryUpdateMemberPrice(model) {
    return { type: types.CATEGORY_UPDATE_MEMBER_PRICE, model }
}

export function categoryUpdateMemberPriceReset() {
    return { type: types.CATEGORY_UPDATE_MEMBER_PRICE_SUCCESS_RESET }
}

export function uploadProducts(model) {
    return { type: types.UPLOAD_PRODUCT, model }
}

// PO
export function savePurchaseOrder(purchaseOrder, compName) {
    return { type: types.SAVE_PURCHASE_ORDER, purchaseOrder, compName };
}

export function receiveProduct(model) {
    return { type: types.RECEIVE_PRODUCT_PO, model };
}

export function addProductToPO(product) {
    return { type: types.ADD_PRODUCT_PO, product };
}

export function saveVendor(vendor, compName) {
    return { type: types.SAVE_VENDOR, vendor, compName };
}

export function getVendors(page, itemsPerPage) {
    return { type: types.GET_VENDORS, page, itemsPerPage };
}

export function getAccessoryVendors() {
    return { type: types.GET_ACCESSORY_VENDORS };
}

export function getVendorsByCountryState(country, state) {
    return { type: types.GET_VENDORS_BY_COUNTRY_STATE, country, state };
}

export function getVendor(vendorId, compName) {
    return { type: types.GET_VENDOR, vendorId, compName };
}

export function createCategory(category) {
    return { type: types.CREATE_CATEGORY, category };
}

// DOCTORS
export function getDoctors(page, itemsPerPage, branchId) {
    return { type: types.DOCTOR_LIST_LOAD, page, itemsPerPage, branchId };
}

export function activateDoctor(id, itemsPerPage) {
    return { type: types.DOCTOR_ACTIVATE, id, itemsPerPage };
}

export function inactivateDoctor(id, itemsPerPage) {
    return { type: types.DOCTOR_INACTIVATE, id, itemsPerPage };
}

export function saveDoctor(doctor, compName) {
    return { type: types.DOCTOR_SAVE, doctor, compName };
}

// Purchase Order
export function getPurchaseOrder(id, branchId, compName) {
    return { type: types.PURCHASE_ORDER_LOAD, id, branchId, compName };
}

export function getPurchaseOrderProduct(id) {
    return { type: types.PURCHASE_ORDER_PRODUCT, id };
}

export function getPurchaseOrders(model) {
    return { type: types.PO_LIST_LOAD, model };
}

export function getPurchaseOrderForBulkTransfer(model) {
    return { type: types.PO_FOR_BULK_TRANSFER, model };
}

export function removePOProduct(index) {
    return { type: types.REMOVE_PO_PRODUCT, index };
}

export function cancelPurchaseOrder(id, msg, compName) {
    return { type: types.PURCHASE_ORDER_CANCEL, id, msg, compName };
}

export function openPurchaseOrder(id, msg, compName) {
    return { type: types.PURCHASE_ORDER_OPEN, id, msg, compName };
}

export function onOrderPurchaseOrder(id, msg, compName) {
    return { type: types.PURCHASE_ORDER_ONORDER, id, msg, compName };
}

export function importPO(model) {
    return { type: types.PURCHASE_ORDER_IMPORT, model }
}

export function importPOSOrderTemplate(model) {
    return { type: types.POS_ORDER_IMPORT_TEMPLATE, model }
}

export function importPOSOrderTemplateClear() {
    return { type: types.POS_ORDER_IMPORT_TEMPLATE_CLEAR }
}

export function importPOTemplate(model) {
    return { type: types.PURCHASE_ORDER_IMPORT_TEMPLATE, model }
}

export function importPOCannabisTemplate(model) {
    return { type: types.PURCHASE_ORDER_CANNABIS_TEMPLATE, model }
}

export function importPOVapeTemplate(model) {
    return { type: types.PURCHASE_ORDER_VAPE_TEMPLATE, model }
}

export function importEmployeeTemplate(model) {
    return { type: types.EMPLOYEE_IMPORT_TEMPLATE, model }
}

// Inventory Adjust
export function getInventoryAdjust(model) {
    return { type: types.GET_INVENTORY_ADJUST, model };
}

export function saveInventoryAdjust(model) {
    return { type: types.SAVE_INVENTORY_ADJUST, model }
}

// Transfer Products
export function getWarehouses(branchId) {
    return { type: types.WAREHOUSES_GET, branchId };
}

export function getProductsInTransit(branchId) {
    return { type: types.PRODUCTS_IN_TRANSIT_LOAD, branchId };
}

export function getProductsGroupedFromWarehouse(model) {
    return { type: types.PRODUCTWAREHOUSE_GROUPED_LIST_LOAD, model };
}

export function sendBulkTransfer(model) {
    return { type: types.SEND_BULK_TRANSFER, model };
}

export function getProductsAutocompleteFromWarehouse(model) {
    return { type: types.PRODUCTWAREHOUSE_AUTOCOMPLETE_LIST_LOAD, model };
}

export function getProductsBarcodeInventoryAudit(model) {
    return { type: types.GET_PRODUCT_BARCODE_INVENTORY_AUDIT, model };
}

export function getProductsFromExcelBulkTransfer(model) {
    return { type: types.BULK_TRANSFER_EXCEL_SEARCH, model };
}


//GET ALL ONLINE CAMPAIGNs
export function getAllOnlineCampaigns(model) {
    return { type: types.CAMPAIGN_GET_ALL_ONLINE, model };
}

export function getBulkTransfers(model) {
    return { type: types.BULK_TRANSFER_LIST_LOAD, model };
}

export function getBulkTransfersById(id) {
    return { type: types.BULK_TRANSFER_By_ID, id };
}

export function getProductQuantity(model) {
    return { type: types.BULK_TRANSFER_PPRODUCT_QUANTITY, model };
}

export function confirmBulkTransfers(id) {
    return { type: types.BULK_TRANSFER_CONFIRM, id }
}

export function getPendingBulkTransferProducts(model) {
    return { type: types.GET_PENDING_BULK_TRANSFER_PRODUCTS, model }
}

export function transferProductToWarehouse(model) {
    return { type: types.TRANSFER_PRODUCT_WAREHOUSE, model };
}

export function WpInventorySyncronization(model) {
    return { type: types.WORDPRESS_SYNC_ALL_PRODUCTS, model };
}

export function lookupUnmappedProducts(model) {
    return { type: types.WORDPRESS_LOOKUP_UNMAPPED_PRODUCTS, model };
}

export function cleanComponentsTable(parentCompName, childCompName) {
    return { type: types.CLEAN_COMPONENTS_TABLE, parentCompName, childCompName };
}

export function mergeProductWarehouse(model) {
    return { type: types.MERGE_PRODUCT_WAREHOUSE, model };
}

export function refreshWarehouses() {
    return { type: types.PRODUCT_WAREHOUSE_REFRESH };
}

export function setSelectAdjustmentProduct(product) {
    return { type: types.SET_SELECTED_PRODUCT_ADJUSTMENT, product };
}

export function sendTransferProduct(product) {
    return { type: types.SEND_TRANSFER_PRODUCT, product };
}

export function sendBulkToUnitProduct(product) {
    return { type: types.SEND_BULKTOUNIT_PRODUCT, product };
}

export function clearSelectAdjustmentProduct(product) {
    return { type: types.CLEAR_SELECTED_PRODUCT_ADJUSTMENT, product };
}

export function adjustProductQty(model) {
    return { type: types.ADJUST_PRODUCT_QTY, model };
}

export function adjustProductWarehouse(model) {
    return { type: types.ADJUST_PRODUCT_WAREHOUSE, model };
}

export function convertBulkToUnit(model) {
    return { type: types.CONVERT_BULK_TO_UNIT, model };
}

export function clearWarehouses() {
    return { type: types.WAREHOUSES_CLEAR };
}

export function clearOnHoldQty(model) {
    return { type: types.CLEAR_ONHOLD_QTY, model }
}

export function getProductInventoryByBranch(model) {
    return { type: types.GET_PRODUCT_INVENTORY_BY_BRANCH, model }
}

export function cleanProductInventoryByBranch() {
    return { type: types.CLEAN_PRODUCT_INVENTORY_BY_BRANCH }
}

export function transferProductsToWH(model) {
    return { type: types.TRANSFER_PRODUCTS_TO_WAREHOUSE, model }
}

// AUDIT
export function getAudit(model) {
    return { type: types.GET_AUDIT, model };
}

export function getAudits(model) {
    return { type: types.GET_AUDITS, model };
}

export function saveAudit(model, compName) {
    return { type: types.AUDIT_SAVE, model, compName };
}

export function deleteAudit(model, branchId, itemId) {
    return { type: types.AUDIT_DELETE, model, branchId, itemId }
}

export function filterAuditListStatus(model) {
    return { type: types.FILTER_AUDIT_LIST_STATUS, model }
}

export function removeProductInAduit(model) {
    return { type: types.AUDIT_PRODUCT_REMOVE, model };
}

export function addProductsToAduit(model) {
    return { type: types.AUDIT_PRODUCT_ADD, model };
}

export function updateAuditName(model) {
    return { type: types.AUDIT_UPDATE_NAME, model };
}

export function updateAuditProductQuantity(model) {
    return { type: types.AUDIT_PRODUCT_UPDATE_QUANTITY, model };
}

export function updateAuditProductExpectedQuantity(model) {
    return { type: types.AUDIT_PRODUCT_UPDATE_EXPECTED_QTY, model };
}

export function updateAuditProductDiffQty(model) {
    return { type: types.AUDIT_PRODUCT_UPDATE_DIFF_QTY, model };
}

export function updateAuditProductNotes(model) {
    return { type: types.AUDIT_PRODUCT_UPDATE_NOTES, model };
}

export function getAuditWarehouses(model) {
    return { type: types.AUDIT_WAREHOUSES, model };
}

export function completeAudit(model) {
    return { type: types.AUDIT_COMPLETE, model };
}

export function verifyAudit(model) {
    return { type: types.AUDIT_VERIFY, model };
}

export function recountAudit(model) {
    return { type: types.AUDIT_RECOUNT, model };
}

export function auditProducts(model) {
    return { type: types.AUDIT_PRODUCTS, model };
}

export function auditCategory(model) {
    return { type: types.AUDIT_CATEGORY, model };
}

export function getBrands() {
    return { type: types.GET_BRANDS };
}

export function auditBrand(model) {
    return { type: types.AUDIT_BRAND, model };
}

export function getAuditUncounted(model) {
    return { type: types.AUDIT_UNCOUNTED, model };
}

export function getAuditCategories(model) {
    return { type: types.AUDIT_CATEGORIES, model };
}

// WEIGHT
export function createWeightSetting(weightSetting, compName) {
    return { type: types.WEIGHT_SETTING_SAVE, weightSetting, compName };
}

export function getWeightSetting(weightSettingId, compName) {
    return { type: types.WEIGHT_SETTING_GET, id: weightSettingId, compName };
}

export function getWeightSettings() {
    return { type: types.WEIGHT_SETTING_GET_ALL };
}

// PRICE MATRIX
export function getPriceMatrices() {
    return { type: types.PRICE_MATRIX_GET_ALL };
}

export function getPriceMatrix(id, compName) {
    return { type: types.PRICE_MATRIX_GET, id, compName };
}

export function savePriceMatrix(priceMatrix, compName) {
    return { type: types.PRICE_MATRIX_SAVE, priceMatrix, compName };
}

export function applyPriceMatrix(model) {
    return { type: types.PRICE_MATRIX_PRODUCTS_APPLY, model };
}

// DEVICE
export function createDevice(device, compName) {
    return { type: types.DEVICE_SAVE, device, compName };
}

export function getDevice(deviceId, branchId, compName) {
    return { type: types.DEVICE_GET, id: deviceId, branchId, compName };
}

export function getDevices(model) {
    return { type: types.DEVICE_GET_ALL, model };
}

export function updateDeviceIp(id, ip) {
    return { type: types.UPDATE_DEVICE_IP, id, ip };
}

// DEVICE TYPE
export function getDeviceTypes() {
    return { type: types.DEVICETYPE_GET_ALL };
}

//DEVICE ROLE
export function getDeviceRoles() {
    return { type: types.DEVICEROLE_GET_ALL };
}

export function saveDeviceRole(roleModel, compName) {
    return { type: types.SAVE_DEVICEROLE, roleModel, compName };
}

//DEVICE WORKSTATION
export function getDeviceWorkStations(branchId) {
    return { type: types.DEVICEWORKSTATION_GET_ALL, branchId };
}

export function saveDeviceWorkStation(workstationModel, compName) {
    return { type: types.DEVICEWORKSTATION_SAVE, workstationModel, compName };
}

//BANK DEPOSITS
export function getBankDeposits(model) {
    return { type: types.BANKDEPOSITS_GET_ALL, ...model };
}

export function getBankDeposit(model) {
    return { type: types.BANKDEPOSITS_GET, ...model };
}

export function insertBankDeposit({ model, compName }) {
    return { type: types.BANKDEPOSITS_INSERT, model, compName };
}

export function updateBankDeposit({ model, compName }) {
    return { type: types.BANKDEPOSITS_UPDATE, model, compName };
}

//SAFE MANAGEMENT
export function getSafeManagements(model) {
    return { type: types.SAFEMANAGEMENT_GET_ALL, model };
}

export function saveSafeManagement({ model, compName }) {
    return { type: types.SAFEMANAGEMENT_INSERT, model, compName };
}

//CASH FLOW
export function getCashFlows(model) {
    return { type: types.CASHFLOW_GET_ALL, model };
}

export function getCashFlow(cashFlowId, branchId) {
    return { type: types.CASHFLOW_GET, cashFlowId, branchId };
}

export function cashInAmount(amount, deviceId, compName, branchId) {
    return { type: types.CASHFLOW_SAVE_CASHIN, amount, deviceId, compName, branchId };
}

export function cleanCashFlowError() {
    return { type: types.CLEAN_CASHFLOW_SAVED_CASHIN_ERROR };
}

export function cashOutAmount(compName) {
    return { type: types.CASHFLOW_SAVE_CASHOUT, compName };
}

export function clearCashFlow() {
    return { type: types.CLEAR_CASHFLOW };
}

export function cashOutAmountManual(amount, compName) {
    return { type: types.CASHFLOW_SAVE_CASHOUTMANUAL, amount, compName };
}

export function cashDrop(model) {
    return { type: types.CASHFLOW_SAVE_CASHDROP, ...model };
}

export function getCashFlowOrders(cashFlowId, branchId) {
    return { type: types.CASHFLOW_ORDERS_GET, cashFlowId, branchId };
}

export function verifyCashOut(model, compName) {
    return { type: types.CASHFLOW_VERIFY_CASHOUT, model, compName };
}

export function notVerifyCashOut(model, compName) {
    return { type: types.CASHFLOW_NOT_VERIFY_CASHOUT, model, compName };
}

export function closeRegisters(model, compName) {
    return { type: types.CASHFLOW_CLOSE_REGISTERS, model, compName };
}

export function closeClosingInProgressRegisters(model) {
    return { type: types.CASHFLOW_CLOSEINPROGRESS_REGISTERS, model };
}

export function cashFlowNotes(notes, id, branchId) {
    return { type: types.CASHFLOW_NOTES, notes, id, branchId };
}

export function cashFlowRegisterCountSave(model) {
    return { type: types.CASHFLOW_REGISTER_COUNT_SAVE, model };
}

export function cashFlowRegisterCountGet(id) {
    return { type: types.CASHFLOW_REGISTER_COUNT_GET, id };
}

export function cashFlowRegisterCountClear() {
    return { type: types.CASHFLOW_REGISTER_COUNT_CLEAR };
}


// PAYMENT
export function createPayment(payment, compName) {
    return { type: types.PAYMENT_SAVE, payment, compName };
}

export function getPayment(paymentId, branchId, compName,) {
    return { type: types.PAYMENT_GET, id: paymentId, branchId, compName };
}

export function getPayments(branchId) {
    return { type: types.PAYMENT_GET_ALL, branchId };
}

// TAXRATE
export function createTaxRate(taxrate, compName) {
    return { type: types.TAXRATE_SAVE, taxrate, compName };
}

export function getTaxRate(taxrateId, branchId, compName) {
    return { type: types.TAXRATE_GET, id: taxrateId, branchId, compName };
}

export function getTaxesRate(branchId) {
    return { type: types.TAXRATE_GET_ALL, branchId };
}

// EMPLOYEE
export function getEmployees(model) {
    return { type: types.EMPLOYEE_LIST_LOAD, model };
}

export function getAllEmployees() {
    return { type: types.GET_ALL_EMPLOYEES };
}

export function getactiveEmployeesOfBranch(model) {
    return { type: types.GET_ACTIVE_EMPLOYEE_BY_BRANCH, model };
}

export function getactiveEmployeesFilter(model) {
    return { type: types.GET_EMPLOYEE_BY_FILTER, model };
}

export function getAutenthicatedEmployee(username) {
    return { type: types.GET_AUTHENTICATED_EMPLOYEE, username };
}

export function getEmployee(model) {
    return { type: types.EMPLOYEE_GET, model };
}

export function saveEmployee(employee, compName) {
    return { type: types.EMPLOYEE_SAVE, employee, compName };
}

export function sendMessage(model) {
    return { type: types.SEND_MESSAGE, model };
}

export function resetMessageStatus() {
    return { type: types.RESET_MESSAGE_SUCCESS };
}

export function sendTestMessage(model) {
    return { type: types.SEND_TEST_MESSAGE, model };
}

export function updateTwilioInfo(model) {
    return { type: types.UPDATE_TWILIO_INFO, model };
}

export function uploadImage(model) {
    return { type: types.UPLOAD_IMAGE, model };
}

export function getEmployeeDetails(model) {
    return { type: types.EMPLOYEE_GET_DETAILS, model };
}

export function resetEmployeeList() {
    return { type: types.RESET_EMPLOYEE_LISTS }
}

// POS
export function getPOS(deviceId, branchId) {
    return { type: types.GET_POS, deviceId, branchId };
}

export function getSellableProducts(filters) {
    return { type: types.GET_SELLABLE_PRODUCTS, model: filters };
}

export function getSellableProductById(filters) {
    return { type: types.GET_SELLABLE_PRODUCT_BY_ID, model: filters };
}

export function setCachedProducts(products) {
    return { type: types.SET_CACHED_PRODUCTS, products };
}

export function searchCachedProducts(products) {
    return { type: types.SEARCH_CACHED_PRODUCTS, products };
}

export function getDeviceByIP(ipAddress, branchId) {
    return { type: types.GET_DEVICE_BY_IP, ipAddress, branchId };
}

export function clearPosFilter() {
    return { type: types.CLEAR_POS_FILTER };
}

export function searchPOSPatients(filters) {
    return { type: types.GET_POS_PATIENTS, model: filters };
}

export function checkProductPOS(productId, compName) {
    return { type: types.GET_PRODUCT_POS, productId, compName };
}

export function saveOrder(order, compName) {
    return { type: types.SAVE_POS_ORDER, order, compName };
}

export function updatePackageReference(orderProductId, packageReference) {
    return { type: types.UPDATE_PACKAGE_REFERENCE, orderProductId, packageReference }
}

export function voidItem(orderId, orderProductId, deviceId, employeeId, branchId, removeProduct, modifiedDate) {
    return { type: types.VOID_POS_ORDER_PRODUCT, orderId, orderProductId, deviceId, employeeId, branchId, removeProduct, modifiedDate };
}

export function saveOrderOffline(order, newProducts, isInspired) {
    return { type: types.SAVE_POS_ORDER_OFFLINE, order, newProducts, isInspired };
}

export function voidOfflineItem(product) {
    return { type: types.VOID_POS_ORDER_OFFLINE_PRODUCT, product };
}

export function addPaymentToOrder(payment) {
    return { type: types.ADD_PAYMENT_POS_ORDER, payment };
}

export function checkOrderUpdateTime(orderId, modifiedDate, updateType = "") {
    return { type: types.CHECK_ORDER_UPDATE_TIME, orderId, modifiedDate, updateType };
}

export function clearTax(orderId) {
    return { type: types.CLEAR_TAX_POS_ORDER, orderId };
}

export function addShippingCost(orderId, shippingCost, modifiedDate) {
    return { type: types.ADD_SHIPPING_COST, orderId, shippingCost, modifiedDate };
}

export function addTipAmount(orderId, tipAmount, modifiedDate) {
    return { type: types.ADD_TIP_AMOUNT, orderId, tipAmount, modifiedDate };
}

export function getOrder(orderId, branchId, deviceId) {
    return { type: types.GET_POS_ORDER, orderId, branchId, deviceId };
}

export function cancelOrder(orderId, model) {
    return { type: types.CANCEL_POS_ORDER, orderId, model };
}

export function cancelAllOpenOrders(branchId, model) {
    return { type: types.CANCEL_ALL_OPEN_ORDERS, branchId, model }
}

export function sendOrderToFulFillment(order) {
    return { type: types.SEND_ORDER_TO_FULFILLMENT, order };
}

export function getManagerApproval(model) {
    return { type: types.MANAGER_APPROVAL, model };
}

export function clearPOSError() {
    return { type: types.CLEAR_POS_ERROR };
}

export function closeRegister(deviceId, branchId, fromCashIn, cashoutAmount) {
    return { type: types.CASHFLOW_CLOSEREGISTER, deviceId, branchId, fromCashIn, cashoutAmount };
}

export function discountOrder(model, compName) {
    return { type: types.SET_ORDER_DISCOUNT, model, compName };
}

export function discountVisitOrder(model, compName) {
    return { type: types.SET_ORDER_VISIT_DISCOUNT, model, compName };
}

export function discountProductsOrder(model, compName) {
    return { type: types.SET_ORDER_PRODUCT_DISCOUNT, model, compName };
}

export const AddStoreToDoorDelivertTime = (model) => {
    return { type: types.CREATE_STORE_TO_DOOR_DELIVERY_TIME, model }
}

export const GetAllStoreToDoorDelivertTime = (model) => {
    return { type: types.GET_ALL_STORE_TO_DOOR_DELIVERY_TIME, model }
}

export const deleteStoreToDoorDelivertTime = (model) => {
    return { type: types.DELETE_STORE_TO_DOOR_DELIVERY_TIME, model }
}

export const updateStoreToDoorDelivertTime = (model) => {
    return { type: types.UPDATE_STORE_TO_DOOR_DELIVERY_TIME, model }
}

export const resetupdateStoreToDoorDelivertTimeState = () => {
    return { type: types.RESET_UPDATE_STORE_TO_DOOR_DELIVERY_TIME }
}

export function removeDiscountOrder(model, compName) {
    return { type: types.REMOVE_ORDER_DISCOUNT, model, compName };
}

export function removeDiscountProductsOrder(model, compName) {
    return { type: types.REMOVE_ORDER_PRODUCT_DISCOUNT, model, compName };
}

export function finalizeOrder(model) {
    return { type: types.FINALIZE_POS_ORDER, ...model };
}

export function checkPriceEstimation(branchId, productId, amount) {
    return { type: types.CHECK_PRICE_ESTIMATION, branchId, productId, amount };
}

export function posEmailReceipt(model) {
    return { type: types.SEND_ORDER_EMAIL_RECEIPT, model };
}

export function posSMSReceipt(model) {
    return { type: types.SEND_ORDER_SMS_RECEIPT, model };
}

export function setProductFilter(productId) {
    return { type: types.SET_PRODUCT_FILTER, productId };
}

export function setProductListEmpty() {
    return { type: types.SET_PRODUCT_LIST_EMPTY };
}

export function assignMember(model) {
    return { type: types.ASSIGN_MEMBER, model };
}

export function getProductSuggestion(model) {
    return { type: types.GET_PRODUCT_SUGGESTION, model };
}

// ORDER
export function getOpenOrders(branchId, page, itemsPerPage) {
    return { type: types.OPEN_ORDERS_GET, branchId, page, itemsPerPage };
}

export function getRecentOrders(branchId) {
    return { type: types.RECENT_ORDERS_GET, branchId };
}

export function getOldOpenOrders(branchId) {
    return { type: types.OLD_OPEN_ORDERS_GET, branchId }
}

export function cancelOpenOrders(model) {
    return { type: types.CANCEL_OPEN_ORDERS, model }
}

export function cancelOpenOnlineOrders(model) {
    return { type: types.CANCEL_OPEN_ONLINE_ORDERS, model }
}

export function getCashFlowOrderDetail(model) {
    return { type: types.GET_CASHFLOW_ORDERS_DETAIL, model }
}

// BRANCH
export function getBranches() {
    return { type: types.BRANCHES_GET };
}

// PRODUCT CATEGORY
export function getCategories(branchId) {
    return { type: types.GET_PRODUCT_CATEGORIES, branchId };
}

export function getCategoriesByBranchs(branchIds) {
    return { type: types.GET_PRODUCT_CATEGORIES_BYBRANCHS, branchIds };
}

export function getCategoryTree(branchId) {
    return { type: types.GET_CATEGORY_TREE, branchId };
}

export function getProductCategory(id, compName) {
    return { type: types.GET_PRODUCT_CATEGORY, id, compName };
}

export function saveCategory(model, compName) {
    return { type: types.SAVE_PRODUCT_CATEGORY, model, compName };
}

export function getClassesOfCannabis() {
    return { type: types.GET_CLASSES_OF_CANNABIS };
}

export function setPriceByCategory(model) {
    return { type: types.SET_PRICE_BY_CATEGORY, model }
}

export function saveProductCategoryTaxProvince(model) {
    return { type: types.SAVE_PRODUCT_CATEGORY_TAX_PROVINCE, model };
}

//CAMPAIGN
export function getCampaigns(model) {
    return { type: types.CAMPAIGN_GET_ALL, model };
}

export function getCampaign(campaignId, branchId, compName) {
    return { type: types.CAMPAIGN_GET, campaignId, branchId, compName };
}

export function saveBulkCampaign(model, compName) {
    return { type: types.CAMPAIGN_SAVE, model, compName };
}

export function deleteCampaign(id, branchId) {
    return { type: types.CAMPAIGN_DELETE, id, branchId }
}

//COMBO

export function getCombos(model) {
    return { type: types.COMBO_GET_ALL, model };
}

export function getCombo(comboId, branchId, compName) {
    return { type: types.COMBO_GET, comboId, branchId, compName }
}

export function saveCombo(model, compName) {
    return { type: types.COMBO_SAVE, model, compName }
}

export function deleteCombo(branchId, id) {
    return { type: types.COMBO_DELETE, branchId, id }
}

//CUSTOM DISCOUNT

export function getCustomizedDiscounts(model) {
    return { type: types.DISCOUNT_GET_ALL, model };
}

export function getCustomizedDiscount(discountId, branchId, compName) {
    return { type: types.DISCOUNT_GET, discountId, branchId, compName }
}

export function saveCustomizedDiscount(model, compName) {
    return { type: types.DISCOUNT_SAVE, model, compName }
}
export function deleteCustomizedDiscount(branchId, discountId) {
    return { type: types.DISCOUNT_DELETE, branchId, discountId };
}

//REFUND
export function addRefundOrder(orderId, refund, compName) {
    return { type: types.ADD_REFUND_ORDER, orderId, refund, compName };
}

// CLOCK IN
export function registerShift(employeeId, imageBase64, compName, isClockIn, branchId, pinNumber) {
    return { type: types.SAVE_CLOCKIN_CLOCKOUT, employeeId, imageBase64, compName, isClockIn, branchId, pinNumber };
}

// SHIFTS
export function getShiftsFilter(model) {
    return { type: types.GET_SHIFTS_FILTER, model };
}

export function getEmployeeTimesheet(model) {
    return { type: types.GET_EMPLOYEE_SHIFT, model };
}
export function getEmployeeTimesheetByStatus(model) {
    return { type: types.GET_EMPLOYEE_SHIFT_BY_STATUS, model };
}
export function saveEmployeeShift(model, compName) {
    return { type: types.SAVE_EMPLOYEE_SHIFT, model, compName };
}

export function saveShift(model, compName) {
    return { type: types.SAVE_SHIFT, model, compName };
}
export const clearEmployeeShift = () => {
    return { type: types.CLEAR_EMPLOYEE_SHIFT}
}

//ORDER
export function getOrderDetail(orderId) {
    return { type: types.GET_ORDER_DETAIL, orderId };
}

export function getPatientOrders(model) {
    return { type: types.GET_PATIENT_ORDERS, model };
}

export function getOrderPatientReward(orderId) {
    return { type: types.GET_ORDER_PATIENT_REWARD, orderId };
}

export function resetReward() {
    return { type: types.SET_PATIENT_REWARD_RESET }
}

//SETTINGS
export function getSettings(branchId, compName) {
    return { type: types.GET_APPLICATION_SETTING, branchId, compName };
}

export const getSettingsIntegration = (branchId) => {
    return { type: types.GET_APPLICATION_SETTING_INTEGRATION, branchId }
}

export function updateSettings(model, compName) {
    return { type: types.SAVE_APPLICATION_SETTING, model, compName };
}

// MIX AND MATCH
export function saveMixAndMatch(model, compName) {
    return { type: types.SAVE_MIX_AND_MATCH, model, compName };
}

export function getMixAndMatchById(id, compName) {
    return { type: types.GET_MIX_AND_MATCH_BY_ID, id, compName };
}

export function getMixAndMatches(page, itemsPerPage, branchId) {
    return { type: types.GET_MIX_AND_MATCHES, page, itemsPerPage, branchId };
}

//REWARD POINTS
export const setRewardPoints = (model, compName) => {
    return { type: types.SAVE_PATIENT_REWARD, model: { model, compName } };
};

export const updateRewardPoint = (model, compName) => {
    return { type: types.UPDATE_PATIENT_REWARD, model: { model, compName } };
};

export const getRewardPoints = (model) => {
    return { type: types.GET_REWARD_POINTS, model };
};

export const updateVisitCount = (model) => {
    return { type: types.UPDATE_PATIENT_VISIT_COUNT, model: { model } };
};

//SPRINGBIG
export const getSpringbigOffers = (model) => {
    return { type: types.GET_SPRINGBIG_OFFERS, model: model };
}

export const getSpringbigRewards = (model) => {
    return { type: types.GET_SPRINGBIG_REWARDS, model: model };
}

export const getSpringbigMemberPoints = (model) => {
    return { type: types.GET_SPRINGBIG_MEMBERPOINTS, model: model };
}

export const postSpringbigOfferDiscount = (model) => {
    return { type: types.POST_SPRINGBIG_OFFER_DISCOUNT, model: model };
}

export const postSpringbigRewardDiscount = (model) => {
    return { type: types.POST_SPRINGBIG_REWARD_DISCOUNT, model: model };
}

//ALPINE IQ
export const alpineIQverifyWallet = (model) => {
    return { type: types.ALPINEIQ_VERIFY_WALLET, model: model };
}

export const alpineIQviewWallet = (model) => {
    return { type: types.ALPINEIQ_VIEW_WALLET, model: model };
}

export const alpineIQregister = (model) => {
    return { type: types.ALPINEIQ_REGISTER, model: model };
}

export const clearAlpineIQ = () => {
    return { type: types.CLEAR_ALPINEIQ }
}

export const postAlpineIQDiscount = (model) => {
    return { type: types.POST_ALPINEIQ_DISCOUNT, model: model };
}

export const alpineIQCheckIn = (model) => {
    return { type: types.ALPINEIQ_CHECKIN, model: model };
}

export const addDutchieOrLeaflyAsOnlineOrder = (model) => {
    return { type: types.ADD_DUTCHIE_OR_LEAFLY_AS_ONLINE_ORDER, model: model };
}


//Ecommerce Admin

export const getProductGroup = (model) => {
    return { type: types.GET_PRODUCT_GROUP_LIST, ...model };
};

export const saveProductGroup = (model) => {
    if (model.productGroupViewModel.Id === 0) {
        return { type: types.SAVE_PRODUCT_GROUP, model };
    }
    else {
        return { type: types.UPDATE_PRODUCT_GROUP, model };
    }
};

export const getStoreRules = (model) => {
    return { type: types.GET_STORE_RULES, model }
}

export const deleteStoreRules = (model) => {
    return { type: types.DELETE_STORE_RULES, model }
}

export const getStoreRuleByID = (model) => {
    return { type: types.GET_STORE_RULE_BY_ID, model }
}

export const saveStoreRulesContent = (model) => {
    return { type: types.SAVE_STORE_RULES_CONTENT, model }
}

export const saveStoreRules = (model) => {
    if (model.Id == 0) {
        return { type: types.SAVE_STORE_RULES, model }
    }
    else {
        return { type: types.UPDATE_STORE_RULES, model };
    }
}

export const getProductGroupById = (model) => {
    return { type: types.GET_PRODUCT_GROUP_BY_ID, model };
};

export const saveHomeSettings = (model) => {
    return { type: types.SAVE_HOME_SETTINGS, model };
}

export const getHomeSettings = (branchId) => {
    return { type: types.GET_HOME_SETTINGS, branchId }
}

export const getWebUISettings = (branchId, compName) => {
    return { type: types.GET_WEB_UI_SETTINGS, branchId, compName }
}
export const getDeliveryZone = (model) => {
    return { type: types.GET_DELIVERY_ZONE, model }
}

export const createDeliveryZone = (model) => {
    return { type: types.CREATE_DELIVERY_ZONE, model }
}

export const deleteDeliveryZone = (model) => {
    return { type: types.DELETE_DELIVERY_ZONE, model }
}

export const updateDeliveryZone = (model) => {
    return { type: types.UPDATE_DELIVERY_ZONE, model }
}

export const updateWebUISettings = (model) => {
    return { type: types.SAVE_WEB_UI_SETTINGS, model }
}
export const getHomeSettingsSuccess = (model) => {
    return { type: types.GET_HOME_SETTINGS_SUCCESS, model }
}

export const getHomeSettingsError = (model) => {
    return { type: types.GET_HOME_SETTINGS_ERROR, model }
}

export const updateHomeSettings = (model) => {
    return { type: types.UPDATE_HOME_SETTINGS, model }
}

export const getProductGroupHome = (model) => {
    return { type: types.GET_PRODUCT_GROUP_HOME, ...model }
};

//PinPad

export const authPinPassword = (model) => {
    return { type: types.AUTH_PIN_PASSWORD, model }
}

export const validatePinPassword = (model) => {
    return { type: types.VALIDATE_PIN_PASSWORD, model }
}

export const resetPinPassword = () => {
    return { type: types.RESET_VALIDATE_PIN_PASSWORD }
}

export const newPin = (compName) => {
    return { type: types.NEW_PIN, compName }
}

export const lockPinPassword = () => {
    return { type: types.AUTH_PIN_LOCK }
}

export const setPinUserToStore = user => {
    return { type: types.SET_USER_PIN_TO_STORE, user }
}

//CHECKIN
export const addToCheckIn = (id) => {
    return { type: types.ADD_CHECK_IN, id }
}

export const checkinSearch = (model) => {
    return { type: types.CHECK_IN_SEARCH, model }
}

export const addToCheckInSuccess = () => {
    return { type: types.ADD_CHECK_IN_SUCCESS }
}

export const addToCheckInFail = (error) => {
    return { type: types.ADD_CHECK_IN_FAIL, error }
}

export const cleanAddCheckIn = () => {
    return { type: types.CLEAN_ADD_CHECKIN_STORE }
}

export const removeCheckIn = (id) => {
    return { type: types.REMOVE_CHECK_IN, id }
}

export const removeCheckInSuccess = (list) => {
    return { type: types.REMOVE_CHECK_IN_SUCCESS, list }
}

export const getCheckIn = (model) => {
    return { type: types.GET_CHECK_IN, model }
}

export const mergeMember = (model) => {
    return { type: types.SEND_MERMBER_MERGE, model }
}

export const getCheckInSuccess = (list) => {
    return { type: types.GET_CHECK_IN, list }
}

export const getCheckInFail = (error) => {
    return { type: types.GET_CHECK_IN_FAIL, error }
}

export const getCheckInById = (id) => {
    return { type: types.GET_CHECK_IN_BY_ID, id };
}

//SCHEDULE
export const getSchedules = (model) => {
    return { type: types.GET_SCHEDULES, model }
}

export const getEmployeeSchedules = (model) => {
    return { type: types.GET_SCHEDULE_BY_EMPLOYEE, model }
}

export const createSchedule = (model) => {
    return { type: types.CREATE_SCHEDULE, model }
}

export const createScheduleRecursive = (model) => {
    return { type: types.CREATE_SCHEDULE_RECURSIVE, model }
}

export const addNewTimeSlot = (model) => {
    return { type: types.ADD_NEW_TIME_SLOT, model }
}

export const removeTimeSlot = (model) => {
    return { type: types.REMOVE_TIME_SLOT, model }
}

export const getCustomTimeSlots = (model) => {
    return { type: types.GET_CUSTOM_TIME_SLOTS, model }
}

export const removeSchedule = (scheduleId) => {
    return { type: types.REMOVE_SCHEDULE, scheduleId }
}

export const removeScheduleRecursive = (scheduleRecursiveId) => {
    return { type: types.REMOVE_SCHEDULE_RECURSIVE, scheduleRecursiveId }
}

export const sendSchedule = (model) => {
    return { type: types.SEND_SCHEDULE, model }
}

export const updateSchedule = (model) => {
    return { type: types.UPDATE_SCHEDULE, model }
}

export const getOnlineOrder = (model) => {
    return { type: types.GET_ONLINE_ORDER, model }
}

export const clearUnprintedOrders = (branchId) => {
    return { type: types.CLEAR_UNPRINTED_ORDER, branchId }
}

export const getOnlineOrderDetails = (orderId) => {
    return { type: types.GET_ONLINE_ORDER_DETAILS, orderId }
}

export const getOnlineOrderDetailsByCode = (model) => {
    return { type: types.GET_ONLINE_ORDER_DETAILS_BY_CODE, model }
}

export const getOnlineOrdersQueue = (model) => {
    return { type: types.GET_ONLINE_ORDERS_QUEUE, model }
}

export const cancelOnlineOrder = (model) => {
    return { type: types.CANCEL_ONLINE_ORDER, model }
}

export const getOpenOnlineOrdersCount = (branchId) => {
    return { type: types.GET_OPEN_ONLINE_ORDERS_COUNT, branchId }
}

export const getWordpressOrdersUpdate = (branchId) => {
    return { type: types.GET_WORDPRESS_ORDER_LIST_UPDATE, branchId }
}

export const getManualWordpressOrdersUpdate = (branchId) => {
    return { type: types.GET_MANUAL_WORDPRESS_ORDER_LIST_UPDATE, branchId }
}

export const getPickUpOrdersQueue = (branchId) => {
    return { type: types.GET_PICKUP_ORDERS_QUEUE, branchId }
}

export const getPickUpOrderDetailsByOrderId = (model) => {
    return { type: types.GET_PICKUP_ORDER_DETAILS_BY_CODE, model }
}

export const updatePickUpProducts = (orderProductId, unscannedQty, pkgReference) => {
    return { type: types.UPDATE_PICKUP_PRODUCTS, orderProductId: orderProductId, unscannedQty: unscannedQty, pkgReference: pkgReference }
}

export const generateOrderBasedOnlineOrder = (model) => {
    return { type: types.GENERATE_ORDER_BASED_ONLINE_ORDER, model }
}

export const getPrescriptions = (patientId) => {
    return { type: types.GET_PRESCRIPTIONS_BY_PATIENT, patientId }
}

export const getStoreToDoorPickupTime = (branchId, pickupDate) => {
    return { type: types.GET_STORETODOOR_PICKUP_TIME, branchId, pickupDate }
}

export const getStoreToDoorLocationInformation = (branchId) => {
    return { type: types.GET_STORETODOOR_LOCATION_INFO, branchId }
}

export const createPrescription = (model) => {
    return { type: types.CREATE_PRESCRIPTION, model }
}

export const updateStatusOnlineOrder = (model) => {
    return { type: types.UPDATE_STATUS_ONLINE_ORDER, model }
}


export const syncProductsToLeafly = (branchId) => {
    return { type: types.SYNC_PRODUCTS_TO_LEAFLY, branchId }
}

export const syncProductsToWeedmaps = (branchId) => {
    return { type: types.SYNC_PRODUCTS_TO_WEEDMAPS, branchId }
}

export const trackingDrawerOpen = (model) => {
    return { type: types.TRACK_DRAWER_OPEN, model }
}

export const getMonerisReceiptByOrderId = (model) => {
    return { type: types.GET_MONERIS_RECEIPT_BY_ORDERID, model }
}

export const getInventoryFlag = (branchId) => {
    return { type: types.GET_INVENTORY_FLAG, branchId }
}

export const clearInventoryFlag = (branchId, productId) => {
    return { type: types.CLEAR_INVENTORY_FLAG, branchId, productId }
}

export const signUpOnlineUser = (model) => {
    return { type: types.SIGN_UP_ONLINE_USER, model }
}

export const giftCardInitialization = (model) => {
    return { type: types.GIFT_CARD_INITIALIZATION, model }
}

export const giftCardDataInquiry = (model) => {
    return { type: types.GIFT_CARD_DATA_INQUIRY, model }
}

export const giftCardcheckingBalance = (model) => {
    return { type: types.GIFT_CARD_BALANCE_PAGE_CHECK, model }
}

export const giftCardCreateOrReload = (model) => {
    return { type: types.GIFT_CARD_CREATE_RELOAD, model }
}

export const giftCardPurchase = (model) => {
    return { type: types.GIFT_CARD_PURCHASE, model }
}

export const giftCardActivation = (model) => {
    return { type: types.GIFT_CARD_ACTIVATION, model }
}

export const giftCardDeactivation = (model) => {
    return { type: types.GIFT_CARD_DEACTIVATION, model }
}

export const giftCardRefund = (model) => {
    return { type: types.GIFT_CARD_REFUND, model }
}

export const importProductsFromCatalog = (branchId) => {
    return { type: types.IMPORT_PRODUCTS_FROM_CATALOG, branchId }
}

export const importAccessoryFromCatalog = (vendorId) => {
    return { type: types.IMPORT_ACCESSORY_FROM_CATALOG, vendorId }
}

export const updateBCClosingInventory = (model) => {
    return { type: types.UPDATE_BC_CLOSING_INVENTORY, model }
}

export const updateClosingInventory = (model) => {
    return { type: types.UPDATE_CLOSING_INVENTORY, model }
}

export const getClosingInventoryStatus = (model) => {
    return { type: types.GET_CLOSING_INVENTORY_PRODUCT, model }
}

export const birchmountGiftCardOperation = (model) => {
    return { type: types.BIRCHMOUNT_GIFTCARD_OPERATION, model }
}

export const birchmountGiftCardPurchase = (model) => {
    return { type: types.BIRCHMOUNT_GIFT_CARD_PURCHASE, model }
}

export const birchmountGiftCardRefund = (model) => {
    return { type: types.BIRCHMOUNT_GIFT_CARD_REFUND, model }
}

export const paystoneGiftCardOperation = (model) => {
    return { type: types.PAYSTONE_GIFTCARD_OPERATION, model }
}

export const paystoneGiftCardPurchase = (model) => {
    return { type: types.PAYSTONE_GIFTCARD_PURCHASE, model }
}

export const chargeGiftCard = (model) => {
    return { type: types.CHARGE_GIFT_CARD_TO_ORDER, model }
}

export const paystoneGiftCardRefund = (model) => {
    return { type: types.PAYSTONE_GIFTCARD_REFUND, model }
}

export const idOrderHistoryDialog = (id) => {
    return { type: types.ID_ORDER_HISTORY_DIALOG, id }
}

export const clearProductList = () => {
    return { type: types.CLEAR_PRODUCT_LIST }
}

export const clearPOList = () => {
    return { type: types.CLEAR_PO_LIST }
}

export const clearProductTypeList = () => {
    return { type: types.CLEAR_PRODUCT_TYPE_LIST }
}

export const clearCategoryTree = () => {
    return { type: types.CLEAR_CATEGORY_TREE }
}

export const clearProductWarehousesList = () => {
    return { type: types.CLEAR_PRODUCT_WAREHOUSES_LIST }
}

export const clearBulkTransferList = () => {
    return { type: types.CLEAR_BULK_TRANSFER_LIST }
}

export const clearBrandList = () => {
    return { type: types.CLEAR_BRAND_LIST }
}

export const clearInventoryAudit = () => {
    return { type: types.CLEAR_INVENTORY_AUDIT }
}

export const clearAuditList = () => {
    return { type: types.CLEAR_AUDIT_LIST }
}

export const clearInventoryAdjust = () => {
    return { type: types.CLEAR_INVENTORY_ADJUST }
}

export const clearPriceMatrix = () => {
    return { type: types.CLEAR_PRICE_MATRIX }
}

export const clearEmployeeList = () => {
    return { type: types.CLEAR_EMPLOYEE_LIST }
}

export const clearMemberOrderList = () => {
    return { type: types.CLEAR_MEMBER_ORDER_LIST }
}

export const clearMemberList = () => {
    return { type: types.CLEAR_MEMBER_LIST }
}

//MOOD
export const addMood = (name, branchId) => {
    return { type: types.ADD_MOOD, name, branchId }
}

export const assignMood = (productId, moodId, branchId) => {
    return { type: types.ASSIGN_MOOD, productId, moodId, branchId }
}

export const getProductMoods = (productId) => {
    return { type: types.GET_PRODUCT_MOODS, productId }
}

export const getMoods = () => {
    return { type: types.GET_MOODS }
}

export const resetAssignSuccess = () => {
    return { type: types.RESET_ASSIGN_MOODS }
}

export const deleteMood = (productId, moodId) => {
    return { type: types.DELETE_MOOD, productId, moodId }
}

export const resetAddMood = () => {
    return { type: types.RESET_ADD_MOOD }
}

//TERPENE
export const addTerpene = (name, branchId) => {
    return { type: types.ADD_TERPENE, name, branchId }
}

export const assignTerpene = (productId, terpeneId) => {
    return { type: types.ASSIGN_TERPENE, productId, terpeneId }
}

export const getProductTerpenes = (productId) => {
    return { type: types.GET_PRODUCT_TERPENES, productId }
}

export const getTerpenes = () => {
    return { type: types.GET_TERPENES }
}

export const resetAssignTerpeneSuccess = () => {
    return { type: types.RESET_ASSIGN_TERPENES }
}

export const deleteTerpene = (productId, terpeneId) => {
    return { type: types.DELETE_TERPENE, productId, terpeneId }
}

export const resetAddTerpene = () => {
    return { type: types.RESET_ADD_TERPENE }
}

export const resetGetTerpenes = () => {
    return { type: types.RESET_GET_TERPENES }
}

export const saveTerpene = (terpeneId, productId, min, max) => {
    return { type: types.SAVE_TERPENE, terpeneId, productId, min, max }
}


//MINOR CANABINOID
export const addMinorCanabinoid = (name, abbrev, branchId) => {
    return { type: types.ADD_MINORCANABINOID, name, abbrev, branchId }
}

export const assignMinorCanabinoid = (productId, minorCanabinoidId) => {
    return { type: types.ASSIGN_MINORCANABINOID, productId, minorCanabinoidId }
}

export const getProductMinorCanabinoids = (productId) => {
    return { type: types.GET_PRODUCT_MINORCANABINOIDS, productId }
}

export const getMinorCanabinoids = () => {
    return { type: types.GET_MINORCANABINOIDS }
}

export const resetAssignMinorCanabinoidSuccess = () => {
    return { type: types.RESET_ASSIGN_MINORCANABINOIDS }
}

export const deleteMinorCanabinoid = (productId, minorCanabinoidId) => {
    return { type: types.DELETE_MINORCANABINOID, productId, minorCanabinoidId }
}

export const resetAddMinorCanabinoid = () => {
    return { type: types.RESET_ADD_MINORCANABINOID }
}

export const resetGetMinorCanabinoids = () => {
    return { type: types.RESET_GET_MINORCANABINOIDS }
}

export const saveMinorCanabinoid = (minorCanabinoidId, productId, min, max) => {
    return { type: types.SAVE_MINORCANABINOID, minorCanabinoidId, productId, min, max }
}

export const GetProductInventoryLog = (model) => {
    return { type: types.GET_PRODUCT_INVENTORY_BY_BRANCH_DATE, model }
}

export const getMultiBranchInventory = (model) => {
    return { type: types.GET_MULTI_BRANCH_INVENTORY, model }
}

export const setRestockQty = (model) => {
    return { type: types.SET_RESTOCK_QTY, model }
}

export const getSingleBranchInventory = (model) => {
    return { type: types.GET_SINGLE_PRODUCT_INVENTORY, model }
}

export const syncFromCatalog = (model) => {
    return { type: types.SYNC_FROM_CATALOG, model }
}

export const submitReportAutomation = (model) => {
    return { type: types.SEND_REPORT_AUTOMATION, model }
}

export const getReportAutomationInfo = (model) => {
    return { type: types.GET_REPORT_AUTOMATION_INFO, model }
}

export const updateReportAutomationInfo = (model) => {
    return { type: types.UPDATE_REPORT_AUTOMATION_INFO, model }
}

export const deleteReportAutomationInfo = (model) => {
    return { type: types.DELETE_REPORT_AUTOMATION, model }
}

export const getStoreLockDateNTime = (branchId) => {
    return { type: types.GET_STORE_LOCK_DATE_AND_TIME, branchId };
}

export const AddStoreLockDateNTime = (model) => {
    return { type: types.CREATE_STORE_LOCK_DATE_AND_TIME, model }
}

export const deleteStoreLockDateNTime = (model) => {
    return { type: types.DELETE_STORE_LOCK_DATE_AND_TIME, model }
}

export const updateStoreLockDateNTime = (model) => {
    return { type: types.UPDATE_STORE_LOCK_DATE_AND_TIME, model }
}

//Bulk Price Update
export const uploadexcel = (model) => {
    return { type: types.BULK_PRICE_UPDATE_BY_EXCEL, model }
}
export const getBulkPriceUpdateSchedular = (branchId, page, itemsPerPage) => {
    return { type: types.GET_BULK_PRICE_UPDATE_SCHEDULAR, branchId, page, itemsPerPage }
}
export const deleteBulkPriceList = (schedularId) => {
    return { type: types.DELETE_BULK_PRICE_LIST, schedularId }
}
export const updateBulkPriceList = () => {
    return { type: types.UPDATE_BULK_PRICE_LIST }
}
export const postNewProductImageAction = (model) => {
    return { type: types.POST_NEW_PRODUCT_IMAGE, model }
}

export const deleteProductImageAction = (model) => {
    return { type: types.DELETE_PRODUCT_IMAGE_REQUEST, model }
}

export const getProductInfoAction = (productId) => {
    return { type: types.GET_PRODUCT_INFO_REQUEST, productId }
}

export const getSEOSettingsAction = () => {
    return { type: types.GET_STORE_SEO_SETTINGS_REQUEST }
}

export const updateSEOSettingsAction = (model) => {
    return { type: types.UPDATE_STORE_SEO_SETTINGS_REQUEST,model }
}

export const getProductGroupImagesAction = (groupId) => {
    return { type: types.GET_PRODUCT_GROUP_IMAGE_REQUEST,groupId }
}

export const uploadProductGroupImagesAction = (model) => {
    return { type: types.ADD_PRODUCT_GROUP_IMAGE_REQUEST,model }
}

export const deleteProductGroupImagesAction = (model) => {
    return { type: types.DELETE_PRODUCT_GROUP_IMAGE_REQUEST,model }
}

export const adyenPaymentRequest = (model) => {
    return { type: types.ADYEN_PAYMENT_REQUEST, model }
}

export const adyenRefundRequest = (model) => {
    return { type: types.ADYEN_REFUND_REQUEST, model }
}
export function getAllBanners() {
    return { type: types.GET_ALL_BANNER_REQUEST };
}
export const addBanner = (model)=> {
    return { type: types.ADD_BANNER_REQUEST , model};
}
export const getBannerById = (bannerId) => ({
    type: types.GET_BANNER_BY_ID_REQUEST,
     bannerId
});
export const updateBanner = (model) => ({
    type: types.UPDATE_BANNER_REQUEST,
    model
});
export const removeBannerImage = (model) => ({
    type: types.REMOVE_BANNER_IMAGE_REQUEST,
    model
});
export const deleteBannerById = (bannerId) => ({
    type: types.REMOVE_BANNER_BY_ID_REQUEST,
     bannerId
});
